const axios = require('axios');
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
import Hideable from '../classes/hideable';
import InitMediaViewer from './media-viewer';
let inView = require('in-view');

export default function InitInfiniteScrolling() {

	const container = document.querySelector('.infinite-scrolling');
	const html = document.querySelector('html');
	var loading = false;

	if(!container)
		return;

	inView('#end-of-media')
		.on('enter', () => {
			if(!loading && !html.classList.contains('lg-on'))
				Paginate(container, () => { 
					loading = false;
					InitMediaViewer();
				});
		});
}

function Paginate(container, callback) {
	const loadingSpinner = new Hideable(document.querySelector('#loading-spinner'), true);
	const limit = container.getAttribute('data-limit') ?? 10;
	const offset = container.getAttribute('data-offset') ?? 0;
	const total = container.getAttribute('data-total') ?? 0;
	const filter = container.getAttribute('data-filter');
	let url = container.getAttribute('data-fetch-url');

	if(!url.endsWith('/'))
		url += '/';

	let offsetNew = Number(offset) + Number(limit);
	if(offsetNew >= Number(total))
		return;

	loadingSpinner.show();
	axios.get(url + offsetNew + '/' + limit + '/' + filter)
		.then((response) => {
			container.innerHTML += response.data;
			container.setAttribute('data-offset', offsetNew);
			loadingSpinner.hide();
		})
		.catch((error) => {
			console.error(error);
		}).then(() => {
			if(typeof callback === 'function')
				callback();
		});
}